export default __webpack_public_path__ + "static/media/home.1fa17dd9.svg";